import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import {
  AttachArticles,
  ItemWithQuantity,
} from "@coworker/apprestructured/src/task-management/components/AttachArticles/AttachArticles";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { useItemsInfoQueries } from "@coworker/apprestructured/src/shared/hooks/item/useItemsInfo";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemNoAndType } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";

function AttachArticlesDemo() {
  const [itemNosAndType, setItemNosAndType] = useState<ItemNoAndType[]>([]);
  const [disabled, setDisabled] = useState(false);
  const [maxArticles, setMaxArticles] = useState("5");
  const regularItemNos = itemNosAndType
    .filter((item) => item.type === "ART")
    .map((item) => item.no);
  const items: ItemWithQuantity[] = (
    useItemsInfoQueries(regularItemNos)
      .map(({ data }) => data)
      .filter(Boolean) as Item[]
  ).map((item) => ({ ...item, quantity: 1 }));

  return (
    <Demo>
      <Name>AttachArticles</Name>
      <Highlight>
        <FixaListView id="attacharticlesdemo" size="small">
          <AttachArticles
            items={items}
            setItemNosAndType={setItemNosAndType}
            disabled={disabled}
            maxArticles={parseInt(maxArticles) || 0}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="attacharticlesdemo-disabled"
          id="attacharticlesdemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
        <FixaInputField
          id="maxArticles"
          value={maxArticles}
          onChange={(e) => setMaxArticles(e.target.value)}
          type="text"
          label="maxArticles"
        />
      </Actions>
    </Demo>
  );
}

export default memo(AttachArticlesDemo);
